module.exports = __webpack_public_path__ + "img/tiramisu-2.7d49d421.jpg";